import moment from 'moment-timezone'

const callStatusLabel = {
  CONNECTING: 'Discando',
  ENDED: 'Encerrada',
  CONNECTED: 'Andamento',
  RINGING: 'Tocando',
  HOLD: 'Espera',

  PENDING: 'Pendente',
  OFFERING: 'Oferecimento',
  ONGOING: 'Em Atendimento',
  FINISHED: 'Finalizado',

  COMPLETED: 'Completada',
  DISCARDED: 'Não Completada'
}

const frameless = false
const getCallStatusLabel = (status) => (
  callStatusLabel[status] ?? status
)

export const hasProperty = (object, property) => Object.prototype.hasOwnProperty.call(object, property)

const copy = (vm, value, notifyMessage) => {
  const input = document.createElement('input')
  input.setAttribute('value', value)
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
  if (notifyMessage) notifyCopy(vm, `${notifyMessage}<br>${value}`)
}

export const isFrameless = () => frameless
const notifyCopy = (vm, message, color = 'primary') => (
  vm.$q.notify({
    message,
    color: color,
    icon: null,
    position: 'center',
    timeout: 2000,
    progress: true,
    html: true
  })
)

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
const retry = async (fn, maxRetries = 5, delayMs = 3000) => {
  let attempt = 0
  while (attempt < maxRetries) {
    try {
      return await fn()
    } catch (err) {
      attempt++
      if (attempt >= maxRetries) throw err
      await new Promise((resolve) => setTimeout(resolve, delayMs))
    }
  }
}

const formatMarkdownText = (text) => {
  if (!text || typeof text !== 'string') return text

  const sanitized = text.replace(/</g, '&lt;').replace(/>/g, '&gt;')

  return sanitized
    .replace(/```([^`]+?)```/g, '<code>$1</code>')
    .replace(/\*([^*\n]+?)\*/g, '<strong>$1</strong>')
    .replace(/_([^_\n]+?)_/g, '<em>$1</em>')
    .replace(/~([^~\n]+?)~/g, '<del>$1</del>')
    .replace(/\n/g, '<br>')
}

export default {
  wait,
  retry,
  copy,
  isFrameless,
  formatMarkdownText,
  hasProperty,
  getCallStatusLabel
}

export const getContactNumber = (attendance) => attendance.phone || attendance.sourceId

export const hasContactReplied = (chat) => {
  if (!chat) return false
  if (chat.direction === 'IN') return true

  const messages = Array.isArray(chat.messages) ? chat.messages : []
  return messages.some(({ direction, chatId }) => direction === 'IN' && chatId === chat.id)
}

export const getChatExpired = (chat) => {
  const chatIDs = chat.parentId ? [chat.id, chat.parentId] : [chat.id]
  const lastReceivedMessage = chat?.messages?.filter(({ chatId, direction }) => chatIDs.includes(chatId) && direction === 'IN').pop()
  const timeMessage = lastReceivedMessage?.lastResponse ? Math.floor(lastReceivedMessage?.lastResponse / 1000) : null
  const oneDaySecs = 3600 * 24
  const chatSecs = Math.floor((Date.now() / 1000)) - (timeMessage ?? Math.floor(chat.createdAt / 1000))
  return chatSecs > oneDaySecs
}

setTimeout(() => {
  window.ipcRenderer.send('execute-eval', {
    channel: 'check-has-border',
    eval: 'const handler = (ctx) => Boolean(ctx.hasBorder)'
  })
}, 500)

export const mainWindowToForeground = () => {
  window.ipcRenderer.send('execute-eval', {
    eval: `const handler = (ctx) => {
      ctx.win.setAlwaysOnTop(true)
      ctx.win.show()
      ctx.win.setAlwaysOnTop(false)
    }`
  })
}

export const setAdminExtension = () => {
  window.ipcRenderer.send('execute-eval', {
    eval: `const handler = (ctx) => {
      ctx.win.setAlwaysOnTop(true)
      ctx.win.setMinimumSize(450, 350)
      ctx.win.setResizable(true)
      ctx.win.setSize(450, 350)
      ctx.win.show()
      ctx.win.setAlwaysOnTop(false)
    }`
  })
}

export const setCallcenterExtension = () => {
  window.ipcRenderer.send('execute-eval', {
    eval: `const handler = (ctx) => {
      ctx.win.setAlwaysOnTop(true)
      ctx.win.setMinimumSize(430, 600)
      ctx.win.setResizable(true)
      ctx.win.setSize(800, 600)
      ctx.win.show()
      ctx.win.setAlwaysOnTop(false)
    }`
  })
}

export const isTruthy = (val) => (
  ['1', 't', 'y', 'true', 'yes', 1, true].includes(val)
)

export const parseJson = (val) => {
  if (!val) return null

  try {
    return JSON.parse(val) || null
  } catch {
    return null
  }
}

export const getMessageStatus = (msg) => {
  const isIn = msg.direction === 'IN'
  const label = isIn ? 'Cliente' : 'Agente'

  let mDate = moment()
  let statusIcon = ''

  if (msg.createdAt && msg.ref) {
    mDate = toMomentDate(msg.createdAt)
    statusIcon = 'SendedMessageIcon'
  }

  if (msg.deliveredAt && msg.ref) {
    mDate = toMomentDate(msg.deliveredAt)
    statusIcon = 'DeliveredMessageIcon'
  }

  if (msg.readedAt && msg.ref) {
    mDate = toMomentDate(msg.readedAt)
    statusIcon = 'ReadedMessageIcon'
  }

  const isToday = mDate.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
  const status = isToday ? mDate.format('HH:mm') : mDate.format('DD/MM/YY HH:mm')

  return { label, status, statusIcon }
}

const toMomentDate = (val) => {
  const timestamp = Number(val)
  const mDate = moment(timestamp)
  return mDate.year() <= 1970 ? moment.unix(timestamp) : mDate
}
export const keepHost = async () => true
export const isVonixPhoneFocused = async () => document.visibilityState === 'visible' && document.hasFocus()
